function openMobileMenu() {
    const drawer = document.getElementById('mobile-drawer');
    const overlay = document.getElementById('drawer-overlay');
    // Targets both plain <a> links and accordion <summary> elements
    const links = document.querySelectorAll('.mobile-nav-link');
    const menuBtn = document.getElementById('mobile-menu-btn');

    if (drawer) drawer.classList.remove('-translate-x-full');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');

    // Prevent body scroll while drawer is open
    document.body.style.overflow = 'hidden';

    if (overlay) {
        overlay.classList.remove('hidden');
        // Force reflow
        void overlay.offsetWidth;
        overlay.classList.remove('opacity-0');
    }

    // Stagger slide-in animation for all nav links
    links.forEach((link, index) => {
        setTimeout(() => {
            link.classList.remove('translate-x-[-10px]', 'opacity-0');
        }, 80 + index * 55);
    });
}

function closeMobileMenu() {
    const drawer = document.getElementById('mobile-drawer');
    const overlay = document.getElementById('drawer-overlay');
    const links = document.querySelectorAll('.mobile-nav-link');
    const menuBtn = document.getElementById('mobile-menu-btn');
    // Close any open accordion <details> elements so drawer starts fresh on re-open
    const openAccordions = document.querySelectorAll('.mobile-nav-accordion[open]');

    if (drawer) drawer.classList.add('-translate-x-full');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');

    // Restore body scroll
    document.body.style.overflow = '';

    if (overlay) {
        overlay.classList.add('opacity-0');
        setTimeout(() => {
            overlay.classList.add('hidden');
        }, 300);
    }

    // Reset link animation state for next open
    links.forEach((link) => {
        link.classList.add('translate-x-[-10px]', 'opacity-0');
    });

    // Collapse all open accordions after the drawer has slid out
    setTimeout(() => {
        openAccordions.forEach((details) => details.removeAttribute('open'));
    }, 310);
}

// Mobile Search Toggle
function toggleMobileSearch(forceClose = false) {
    const overlay = document.getElementById('mobile-search-overlay');
    const backdrop = document.getElementById('mobile-search-backdrop');
    const input = document.getElementById('mobile-search-input');
    const btn = document.querySelector('button[onclick="toggleMobileSearch()"]');

    if (!overlay) return;

    const isOpen = !overlay.classList.contains('scale-y-0');

    if (isOpen || forceClose === true) {
        // Close
        overlay.classList.add('scale-y-0', 'opacity-0');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        if (backdrop) {
            backdrop.classList.add('opacity-0');
            setTimeout(() => backdrop.classList.add('hidden'), 200);
        }
        document.body.style.overflow = '';
        if (input) input.blur();
    } else {
        // Open
        overlay.classList.remove('scale-y-0', 'opacity-0');
        if (btn) btn.setAttribute('aria-expanded', 'true');
        if (backdrop) {
            backdrop.classList.remove('hidden');
            void backdrop.offsetWidth;
            backdrop.classList.remove('opacity-0');
        }
        document.body.style.overflow = 'hidden';
        setTimeout(() => input && input.focus(), 200);
    }
}

function updateHeaderSpacer() {
    const header = document.getElementById('sticky-header');
    const spacer = document.getElementById('sticky-header-spacer');

    if (!header || !spacer) return;

    // offsetHeight includes padding and borders, but NOT absolute positioned children
    // which is exactly what we want (ignore the overlay)
    const headerHeight = header.offsetHeight;
    spacer.style.height = headerHeight + 'px';
}

window.addEventListener('load', updateHeaderSpacer);
window.addEventListener('resize', updateHeaderSpacer);
// Also update if DOM changes (e.g. font load)
document.addEventListener('DOMContentLoaded', updateHeaderSpacer);

// ==========================================
// Predictive Search Functionality
// ==========================================
(function () {
    const searchInput = document.getElementById('predictive-search-input');
    const searchResults = document.getElementById('predictive-search-results');
    const searchLoading = document.getElementById('search-loading');
    const searchResultsList = document.getElementById('search-results-list');
    const searchNoResults = document.getElementById('search-no-results');
    const searchViewAll = document.getElementById('search-view-all');
    const searchForm = document.getElementById('search-form');

    if (!searchInput || !searchResults) return;

    let debounceTimer;
    let currentQuery = '';

    // Debounce function
    function debounce(func, delay) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(func, delay);
    }

    // Show/hide dropdown
    function showDropdown() {
        searchResults.classList.remove('hidden');
    }

    function hideDropdown() {
        searchResults.classList.add('hidden');
    }

    // Fetch search results from Shopify Predictive Search API
    async function fetchResults(query) {
        if (query.length < 2) {
            hideDropdown();
            return;
        }

        currentQuery = query;
        showDropdown();

        // Show loading
        searchLoading.classList.remove('hidden');
        searchResultsList.innerHTML = '';
        searchNoResults.classList.add('hidden');
        searchViewAll.classList.add('hidden');

        try {
            const response = await fetch(
                `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`
            );
            const data = await response.json();

            // Hide loading
            searchLoading.classList.add('hidden');

            const products = data.resources?.results?.products || [];

            if (products.length === 0) {
                searchNoResults.classList.remove('hidden');
                searchViewAll.classList.add('hidden');
                return;
            }

            // Render results
            searchResultsList.innerHTML = products
                .map(
                    (product) => `
          <a href="${product.url
                        }" class="flex items-center gap-4 p-3 hover:bg-secondary/5 transition-colors border-b border-secondary/10 last:border-b-0">
            <div class="w-14 h-14 rounded-lg overflow-hidden bg-gray-100 shrink-0">
              ${product.image
                            ? `<img src="${product.image}" alt="${product.title}" class="w-full h-full object-cover" loading="lazy">`
                            : '<div class="w-full h-full flex items-center justify-center text-text-subtle"><span class="material-symbols-outlined">image</span></div>'
                        }
            </div>
            <div class="flex-1 min-w-0">
              <h4 class="font-semibold text-text-main text-sm truncate">${highlightMatch(product.title, query)}</h4>
              <p class="text-primary font-bold text-sm">${window.formatMoney(product.price)}</p>
            </div>
          </a>
        `
                )
                .join('');

            // Show view all link
            searchViewAll.href = `/search?q=${encodeURIComponent(query)}&type=product`;
            searchViewAll.classList.remove('hidden');
            searchViewAll.classList.add('flex');
        } catch (error) {
            console.error('Search error:', error);
            searchLoading.classList.add('hidden');
            searchNoResults.classList.remove('hidden');
        }
    }

    // Highlight matching text
    function highlightMatch(text, query) {
        if (!query) return text;
        try {
            const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const regex = new RegExp(`(${escaped})`, 'gi');
            return text.replace(regex, '<mark class="bg-yellow-200 rounded px-0.5">$1</mark>');
        } catch (e) {
            return text;
        }
    }

    // Event Listeners
    searchInput.addEventListener('input', (e) => {
        const query = e.target.value.trim();
        debounce(() => fetchResults(query), 300);
    });

    // Focus shows dropdown if there's content
    searchInput.addEventListener('focus', () => {
        if (searchInput.value.length >= 2) {
            showDropdown();
        }
    });

    // Click outside to close
    document.addEventListener('click', (e) => {
        if (!e.target.closest('#predictive-search-container')) {
            hideDropdown();
        }
    });

    // Keyboard navigation (Escape to close)
    searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            hideDropdown();
            searchInput.blur();
        }
    });

    // Prevent form submit if dropdown is open and results exist
    searchForm.addEventListener('submit', (e) => {
        // Allow normal form submission to search results page
    });
})();

// ==========================================
// Mobile Predictive Search
// ==========================================
(function () {
    const mobileInput = document.getElementById('mobile-search-input');
    const mobileResults = document.getElementById('mobile-search-results');
    const mobileLoading = document.getElementById('mobile-search-loading');
    const mobileResultsList = document.getElementById('mobile-search-results-list');
    const mobileNoResults = document.getElementById('mobile-search-no-results');
    const mobileViewAll = document.getElementById('mobile-search-view-all');

    if (!mobileInput || !mobileResults) return;

    let mobileDebounceTimer;

    function debounce(func, delay) {
        clearTimeout(mobileDebounceTimer);
        mobileDebounceTimer = setTimeout(func, delay);
    }

    function showResults() {
        mobileResults.classList.remove('hidden');
    }

    function hideResults() {
        mobileResults.classList.add('hidden');
    }

    // Highlight matching text
    function highlightMatch(text, query) {
        if (!query) return text;
        try {
            const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const regex = new RegExp(`(${escaped})`, 'gi');
            return text.replace(regex, '<mark class="bg-yellow-200 rounded px-0.5">$1</mark>');
        } catch (e) {
            return text;
        }
    }

    async function fetchMobileResults(query) {
        if (query.length < 2) {
            hideResults();
            return;
        }

        showResults();
        mobileLoading.classList.remove('hidden');
        mobileResultsList.innerHTML = '';
        mobileNoResults.classList.add('hidden');
        mobileViewAll.classList.add('hidden');

        try {
            const response = await fetch(
                `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`
            );
            const data = await response.json();

            mobileLoading.classList.add('hidden');
            const products = data.resources?.results?.products || [];

            if (products.length === 0) {
                mobileNoResults.classList.remove('hidden');
                return;
            }

            // Render results (compact for mobile)
            mobileResultsList.innerHTML = products
                .map(
                    (product) => `
          <a href="${product.url
                        }" class="flex items-center gap-3 p-3 hover:bg-secondary/5 transition-colors border-b border-secondary/10 last:border-b-0">
            <div class="w-12 h-12 rounded-lg overflow-hidden bg-gray-100 shrink-0">
              ${product.image
                            ? `<img src="${product.image}" alt="${product.title}" class="w-full h-full object-cover" loading="lazy">`
                            : '<div class="w-full h-full flex items-center justify-center text-text-subtle"><span class="material-symbols-outlined text-[18px]">image</span></div>'
                        }
            </div>
            <div class="flex-1 min-w-0">
              <h4 class="font-semibold text-text-main text-sm truncate">${highlightMatch(product.title, query)}</h4>
              <p class="text-primary font-bold text-sm">${window.formatMoney(product.price)}</p>
            </div>
          </a>
        `
                )
                .join('');

            mobileViewAll.href = `/search?q=${encodeURIComponent(query)}&type=product`;
            mobileViewAll.classList.remove('hidden');
            mobileViewAll.classList.add('flex');
        } catch (error) {
            console.error('Mobile search error:', error);
            mobileLoading.classList.add('hidden');
            mobileNoResults.classList.remove('hidden');
        }
    }

    mobileInput.addEventListener('input', (e) => {
        const query = e.target.value.trim();
        debounce(() => fetchMobileResults(query), 300);
    });

    mobileInput.addEventListener('focus', () => {
        if (mobileInput.value.length >= 2) {
            showResults();
        }
    });

    mobileInput.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            toggleMobileSearch(true);
        }
    });
})();

// ==========================================
// Secondary Nav Scroll Collapse
// ==========================================
(function() {
    const secondaryNav = document.getElementById('secondary-nav');
    if (!secondaryNav) return;

    window.addEventListener('scroll', () => {
        if (window.scrollY > 20) {
            secondaryNav.style.maxHeight = '0px';
            secondaryNav.style.opacity = '0';
            secondaryNav.style.borderTopColor = 'transparent';
        } else {
            secondaryNav.style.maxHeight = secondaryNav.scrollHeight + 'px';
            secondaryNav.style.opacity = '1';
            secondaryNav.style.borderTopColor = '';
        }
    }, { passive: true });
})();